export enum Role {
    PART_TIME_STAFF = 0,
    SUB_STORE = 1,
    STORE = 2,
    FC = 3,
    HEAD = 4,
    REMOTE_STAFF = 5,
    REMOTE_MANAGER = 6,
}
